module.exports = __webpack_public_path__ + "img/IMG-20200815-WA0007.e8587464.jpg";